import React from "react";
import { Chip } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import RemoveIcon from "@mui/icons-material/Remove";
import { MdStar } from "react-icons/md"; // Usando react-icons

// Props para el componente
interface CellPositionProps {
    position: number; // Posición del 0 al 5
}

export const CellPosition: React.FC<CellPositionProps> = ({ position }) => {
    // Configuración de las posiciones
    const positionConfig = {
        0: {
            label: "Muy alta",
            icon: <MdStar style={{ color: "#FFD700" }} />, // Icono de estrella
            style: {
                borderColor: "#FFD54F",
                color: "#F57F17",
                backgroundColor: "#FFF9C4",
            },
        },
        1: {
            label: "Alta",
            icon: <ArrowUpwardIcon style={{ color: "#4CAF50" }} />, // Icono de flecha arriba verde
            style: {
                borderColor: "#A5D6A7",
                color: "#2E7D32",
                backgroundColor: "#E8F5E9",
            },
        },
        2: {
            label: "Media",
            icon: <RemoveIcon style={{ color: "#FF9800" }} />, // Icono de raya
            style: {
                borderColor: "#FFCC80",
                color: "#EF6C00",
                backgroundColor: "#FFF3E0",
            },
        },
        3: {
            label: "Baja",
            icon: <ArrowDownwardIcon style={{ color: "#F44336" }} />, // Icono de flecha abajo roja
            style: {
                borderColor: "#E57373",
                color: "#B71C1C",
                backgroundColor: "#FFEBEE",
            },
        },
        4: {
            label: "Muy baja",
            icon: <ArrowDownwardIcon style={{ color: "#9E9E9E" }} />, // Flecha gris
            style: {
                borderColor: "#E0E0E0",
                color: "#757575",
                backgroundColor: "#FAFAFA",
            },
        },
        5: {
            label: "Desconocido",
            icon: <RemoveIcon style={{ color: "#9E9E9E" }} />, // Icono gris
            style: {
                borderColor: "#BDBDBD",
                color: "#616161",
                backgroundColor: "#EEEEEE",
            },
        },
    };

    // Fallback si la posición no es válida
    const chipConfig = positionConfig[position] || positionConfig[5];

    return (
        <Chip
            icon={chipConfig.icon}
            label={chipConfig.label}
            style={chipConfig.style}
            size="small"
            variant="outlined"
        />
    );
};
